import React from 'react';
import { Hero } from './components/Hero';
import { ServiceHighlights } from './components/ServiceHighlights';
import { TrustSection } from './components/TrustSection';
import { ContactCTA } from './components/ContactCTA';
export function App() {
  return <main className="bg-dark-bg min-h-screen w-full text-gold-100 selection:bg-gold-400 selection:text-dark-bg" data-id="element-0">
      <Hero data-id="element-1" />
      <ServiceHighlights data-id="element-2" />
      <TrustSection data-id="element-3" />
      <ContactCTA data-id="element-4" />
    </main>;
}